module.exports = __webpack_public_path__ + "static/btn 2_000020.6cdf0438.png";